import { FC, ReactNode } from 'react';
import { TextField, Autocomplete, MenuItem, Chip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { IContract } from '../../models/contract';


interface MultiSelectProps {
  contracts: IContract[];
  handleInput: (e: React.SyntheticEvent, values: IContract[]) => void;
  children?: ReactNode[];
}
export const MultiSelect:FC<MultiSelectProps> = ({contracts, handleInput}) => {
  return (
    <Autocomplete
      sx={{ m: 1, width: 530, border:'.4px solid rgb(196, 199, 199)', borderRadius:2 }}
      multiple
      options={contracts}
      // options={contracts.sort((a, b) => -b.contracttype.localeCompare(a.contracttype))}
      // groupBy={(option) => option.contracttype}
      getOptionLabel={(option) => option.contract}
      disableCloseOnSelect
      renderInput={(params) => (
        <TextField
        {...params}
        InputProps={{ ...params.InputProps, style: { fontFamily:'B Nazanin', fontSize:14, fontWeight:600 } }}
          variant="outlined"
          label=""//"پروژه ها"
          placeholder="پروژه های انتخابی"
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="filled"
            label={option.contract}
            {...getTagProps({ index })}
            sx={{
              p:.7,
              height: "24px",
              background: "#eeebee",
              fontFamily:'B Nazanin', fontSize:14, fontWeight:600,
              border:'.4px solid rgb(196, 199, 199)'
            }}
            deleteIcon={<CancelIcon color='error'/>}
          />
        ))
      }
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option.contractid}
          value={option.contractid}
          sx={{ justifyContent: "space-between", fontFamily:'B Nazanin', fontSize:14, fontWeight:600, direction:'rtl'}}
        >
          {option.contract}
          {selected ? <CheckIcon color="info" sx={{mx:.5, px:.5}}/> : null}
        </MenuItem>
      )}
      onChange={handleInput}
    />
  );
}

